// services/useAuth.ts — Hook split out of auth.tsx so the
// react-refresh ESLint rule stays happy (component files should
// only export components for HMR boundaries to work).

import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './authContext';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be called inside <AuthProvider>');
  }
  return ctx;
}
